module.exports = __webpack_public_path__ + "static/media/code.af65ea64.png";